import React, { useState, useEffect } from "react";
import { AiFillProject } from "react-icons/ai";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Work.scss";

const Work = () => {
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  // Use an object consistently for animate
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(() => {
    const query = '*[_type == "works"]';

    client
      .fetch(query)
      .then((data) => {
        if (!Array.isArray(data)) {
          console.warn("Fetched works is not an array:", data);
          setWorks([]);
          setFilterWork([]);
          return;
        }
        setWorks(data);
        setFilterWork(data);
      })
      .catch((err) => {
        console.error("Error fetching works:", err);
        setWorks([]);
        setFilterWork([]);
      });
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    // animate out
    setAnimateCard({ y: 100, opacity: 0 });

    setTimeout(() => {
      // animate back in
      setAnimateCard({ y: 0, opacity: 1 });

      if (item === "All") {
        setFilterWork(works);
      } else {
        // safety: only call .includes on arrays
        setFilterWork(
          works.filter((work) => {
            if (!work) return false;
            if (Array.isArray(work.tags)) {
              return work.tags.includes(item);
            }
            // optionally log to help debug missing tags
            // console.warn(`Work item missing tags array:`, work);
            return false;
          })
        );
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">
        Transforming Data ➛<span> Insight,</span> Insight ➛<span> Innovation.</span>
      </h2>

      <div className="app__work-filter">
        {["Research", "Machine Learning", "All"].map((item) => (
          <div
            key={item}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map(
          ({
            _id,
            imgUrl,
            codeLink,
            title = "Untitled",
            description = "",
            tags = [],
          }) => (
            <div className="app__work-item app__flex" key={_id || title}>
              <div className="app__work-img app__flex">
                {/* safe src fallback */}
                <img
                  src={imgUrl ? urlFor(imgUrl) : undefined}
                  alt={title}
                  onError={(e) => {
                    // optional: hide broken images or set a placeholder
                    e.currentTarget.style.display = "none";
                  }}
                />

                <motion.div
                  whileHover={{ opacity: [0, 1] }}
                  transition={{
                    duration: 0.25,
                    ease: "easeInOut",
                    staggerChildren: 0.5,
                  }}
                  className="app__work-hover app__flex"
                >
                  {codeLink ? (
                    <a href={codeLink} target="_blank" rel="noreferrer">
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{ duration: 0.25 }}
                        className="app__flex"
                      >
                        <AiFillProject />
                      </motion.div>
                    </a>
                  ) : (
                    <div className="app__flex">
                      <AiFillProject />
                    </div>
                  )}
                </motion.div>
              </div>

              <div className="app__work-content app__flex">
                <h4 className="bold-text">{title}</h4>
                <p
                  className="p-text"
                  style={{ marginTop: 10, textAlign: "justify" }}
                >
                  {description}
                </p>
              </div>
            </div>
          )
        )}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
